import $ from 'jquery';
import Util from '../utils/ui';
import * as CONST from '../utils/constants';

class HealthIndexWheel {
    constructor() {
	}

	init() {
		this.bindEvents();
	}

    bindEvents() {
        let indexDropdown;
        let clickedItems = [];
        let arrowsIndex;
        let currentArrowDegree;
        let dropdownDesktop = $('.dropdowns-wrapper a');

        for (let indexCounterDesktop = 0; indexCounterDesktop < dropdownDesktop.length; indexCounterDesktop += 1) {
            let inputHref = $(dropdownDesktop[indexCounterDesktop]).attr('href');
            let input = $(dropdownDesktop[indexCounterDesktop]);
            if (inputHref) {
                if (inputHref.indexOf('.pdf') !== -1) {
                    $(dropdownDesktop[indexCounterDesktop]).after('<i class="icon-pdf"></i>');
                    $(dropdownDesktop[indexCounterDesktop]).attr('target', '_blank');
                }
            }
        }
        let dropdownMobile = $('.mobile-dropdowns-wrapper a');
        for (let indexCounterMobile = 0; indexCounterMobile < dropdownMobile.length; indexCounterMobile += 1) {
            let inputHref = $(dropdownMobile[indexCounterMobile]).attr('href');
            let input = $(dropdownMobile[indexCounterMobile]);
            if (inputHref) {
                if (inputHref.indexOf('.pdf') !== -1) {
                    $(dropdownMobile[indexCounterMobile]).after('<i class="icon-pdf"></i>');
                    $(dropdownMobile[indexCounterMobile]).attr('target', '_blank');
                }
            }
        }

        const elements = document.querySelectorAll('.dropdowns-wrapper a');
        for (const element of elements) {
            if (!(element.classList.contains('btn')) && element.getAttribute('href')) {
                let href = element.getAttribute('href');
                //REPLACE # FUNCTION
                href = `${href.replace('#', '')}?fromWheel=true`;
                element.setAttribute('href', href);
            }
        }

        const elementsMobile = document.querySelectorAll('.mobile-dropdowns-wrapper a');
        for (const element of elementsMobile) {
            if (!(element.classList.contains('btn')) && element.getAttribute('href')) {
                let href = element.getAttribute('href');
                href = `${href.replace('#', '')}?fromWheel=true`;
                element.setAttribute('href', href);
            }
        }
        const linksAssesment = document.querySelectorAll('.assesment-school-section a');
        for (const element of linksAssesment) {
            if (!(element.classList.contains('btn')) && element.getAttribute('href')) {
                let href = element.getAttribute('href');
                href = `${href.replace('#', '')}?fromWheel=true`;
                element.setAttribute('href', href);
            }
        }
        const linksCommunity = document.querySelectorAll('.community-promo-section a');
        for (const element of linksCommunity) {
            if (!(element.classList.contains('btn')) && element.getAttribute('href')) {
                let href = element.getAttribute('href');
                href = `${href.replace('#', '')}?fromWheel=true`;
                element.setAttribute('href', href);
            }
        }

        this.prepExternalLinks('.dropdowns-wrapper a');
        this.prepExternalLinks('.mobile-dropdowns-wrapper a');
        this.prepExternalLinks('.assesment-school-section a');
        this.prepExternalLinks('.community-promo-section a');

        $('.copy_text').click((e) => {
            e.preventDefault();
            let copyText = $($(e)[0].currentTarget).attr('title');
            navigator.clipboard.writeText(copyText);
            $($(e)[0].currentTarget.parentElement).find('#custom-tooltip').addClass('copied');
            setTimeout(() => {
                $($(e)[0].currentTarget.parentElement).find('#custom-tooltip').removeClass('copied');
            }, 2000);
        });

        if (this.getCookie('selectionItemsCookie') !== null) {
            if (this.getCookie('selectionItemsCookie').length > 0) {
                clickedItems = JSON.parse(getCookie('selectionItemsCookie'));
                this.applyVisitedItems(clickedItems);
            }
        }

        $('.visitedItem').addClass('is-open');

        $('.mobile-dropdowns-wrapper .accordion-parent').click(function accordeonClick(e) {
            if (!$(this).hasClass('is-visited')) {
                let elementDropdownMobile = $(this);
                elementDropdownMobile.addClass('is-visited');
                let mobileIconData = elementDropdownMobile.find('h2.js-accordion-title').data('icon-mobile-clicked');
                let expiryDate = new Date();
                expiryDate.setMonth(expiryDate.getMonth() + 1);
                if ($.inArray(mobileIconData, clickedItems) === -1) {
                    clickedItems.push(mobileIconData);
                    let jsonCookies = JSON.stringify(clickedItems);
                    document.cookie = `selectionItemsCookie=${jsonCookies};expires=${expiryDate};path=/`;
                }
            }
        });
        $('.dropdowns-wrapper .accordion-wrapper').click((e) => {
            this.calculateBottomPaddingOnDropdown();
        });

        $('.js-close-wheel').click((e) => {
            //close wheel dropdown 
            $('.dropdowns-wrapper').removeClass('is-open');
            $('.arrows-wrapper').removeClass('is-open');
            $('.background-wheel').removeClass('is-open');
            $('.js-wheel-wrapper').removeClass('is-open');
            $('.background-wheel').css('transform', 'rotate(0deg)');
            $('.dropdown-content').removeClass('is-open');
            $('.wheel-section').removeClass('is-open');
            let wheel = $('.wheel-section');
            $(wheel).css('padding-bottom', '120px');
        });
		$('.links-area li a').hover((e) => {
            let $this = $(e.currentTarget);
            let $thisImage = $this.closest('li').attr('data-active');
            let $imgContainer = $('.hoverImage');
            $imgContainer.attr('src', $thisImage);
            $this.closest('li').siblings('li').removeClass('is-hovered');
            $this.closest('li').addClass('is-hovered');
        });

        $('.arrow-up').click((e) => {
            //on button arrow up wheel.
            let currentItemSelected = $('*[data-index-area=11]').attr('data-index-area');
            if (!arrowsIndex) {
                arrowsIndex = 11;
                currentArrowDegree = $(`*[data-index-area=${arrowsIndex}]`).attr('data-index-degree');
            } else if (arrowsIndex - 1 < 1) {
                arrowsIndex = 11;
                currentArrowDegree = $(`*[data-index-area=${arrowsIndex}]`).attr('data-index-degree');
            } else {
                arrowsIndex -= 1;
                currentArrowDegree = $(`*[data-index-area=${arrowsIndex}]`).attr('data-index-degree');
            }

            let arrayOfActualItems = [];
            let currentElementList = $('.links-area li a');
            let $actualItemsPosition = $('.links-area li');
            let distanceClockWise = this.rotateClockWise(currentElementList.length, currentItemSelected);
            let $wheelLinksArea = $('.links-area');
            $wheelLinksArea.addClass('fade-out');
            let expiryDate = new Date();
            expiryDate.setMonth(expiryDate.getMonth() + 1);

            if ($.inArray($('*[data-index-area=11]').find('i').attr('class'), clickedItems) === -1) {
                clickedItems.push($('*[data-index-area=11]').find('i').attr('class'));
                let jsonCookies = JSON.stringify(clickedItems);
                document.cookie = `selectionItemsCookie=${jsonCookies};expires=${expiryDate};path=/`;
            }

            for (let i = 0; i < $actualItemsPosition.length; i += 1) {
                let $auxCurrentItem = $($actualItemsPosition[i]);
                let itemObject = {};
                itemObject.icon = $auxCurrentItem.find('[class*="icon"]').attr('class');
                itemObject.text = $auxCurrentItem.find('.text').text();
                itemObject.indexDropdowns = $auxCurrentItem.attr('data-index-dropdown'); //ADDED DROPDOWN 
                arrayOfActualItems.push(itemObject);
            }
            arrayOfActualItems = this.transportClockWise(arrayOfActualItems, distanceClockWise);

            $(() => {
                function fadeOutVisidted() {
                    $('.visitedItem').removeClass('is-open');
                }
                window.setTimeout(fadeOutVisidted, 3000); // 1 second
            });
            $(() => {
                function moveItems() {
                    for (let x = 0; x < $actualItemsPosition.length; x += 1) {
                        let $currentItem = $($actualItemsPosition[x]);
                        $currentItem.find('i').removeClass(); //Removes previous classes
                        $currentItem.find('i').addClass(arrayOfActualItems[x].icon);
                        $currentItem.find('.text').html(arrayOfActualItems[x].text);
                        $currentItem.attr('data-index-dropdown', arrayOfActualItems[x].indexDropdowns); //CHANGING INTO ACTUAL ELEMENT
                    }
                    $('.visitedItem').remove();
                    for (let i = 0; i < clickedItems.length; i += 1) {
                        let auxClass = clickedItems[i].replace(' ', '.');
                        let auxItem = $(`.${auxClass}`);
                        let areaImageIndex = parseInt(auxItem.closest('li').attr('data-index-area'), 0);
                        if (areaImageIndex === 11) {
                            areaImageIndex = 1;
                        } else {
                            areaImageIndex += 1;
                        }
                        $('.background-wheel').after($('<img>', {
                            class: 'visitedItem no-lazy js-webp',
                            'data-image': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                            'data-image-webp': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                            src: `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                        }));
                    }
                }
                window.setTimeout(moveItems, 1000); // 1 second
            });

            $(() => {
                function rotateWheel(currentArrowDegree) {
                    $('.background-wheel').css('transform', `rotate(${currentArrowDegree}deg)`);
                }
                window.setTimeout(rotateWheel(currentArrowDegree), 3000); // 1 second
            });

            $(() => {
                function fadeInItems() {
                    $wheelLinksArea.removeClass('fade-out');
                    $(`.js-dropdown-index-${indexDropdown}`).removeClass('is-open');
                    indexDropdown = $('.active-slice').attr('data-index-dropdown');
                    $(`.js-dropdown-index-${indexDropdown}`).addClass('is-open');
                    $('.visitedItem').addClass('is-open');
                }
                window.setTimeout(fadeInItems, 3000);
            });
        });

        $('.arrow-down').click((e) => {
            //on button arrow down wheel
            let currentItemSelected = $('*[data-index-area=2]').attr('data-index-area');

            let currentItemDegree = $('*[data-index-area=2]').attr('data-index-degree');

            if (!arrowsIndex) {
                arrowsIndex = 2;
                currentArrowDegree = $(`*[data-index-area=${arrowsIndex}]`).attr('data-index-degree');
            } else if (arrowsIndex + 1 > 11) {
                arrowsIndex = 1;
                currentArrowDegree = $(`*[data-index-area=${arrowsIndex}]`).attr('data-index-degree');
            } else {
                arrowsIndex += 1;
                currentArrowDegree = $(`*[data-index-area=${arrowsIndex}]`).attr('data-index-degree');
            }

            let arrayOfActualItems = [];
            let currentElementList = $('.links-area li a');
            let $actualItemsPosition = $('.links-area li');
            let distanceClockWise = this.rotateCounterClockWise(currentElementList.length, currentItemSelected);
            let $wheelLinksArea = $('.links-area');
            $wheelLinksArea.addClass('fade-out');
            let expiryDate = new Date();
            expiryDate.setMonth(expiryDate.getMonth() + 1);
            if ($.inArray($('*[data-index-area=2]').find('i').attr('class'), clickedItems) === -1) {
                clickedItems.push($('*[data-index-area=2]').find('i').attr('class'));
                let jsonCookies = JSON.stringify(clickedItems);
                document.cookie = `selectionItemsCookie=${jsonCookies};expires=${expiryDate};path=/`;
            }

            for (let i = 0; i < $actualItemsPosition.length; i += 1) {
                let $auxCurrentItem = $($actualItemsPosition[i]);
                let itemObject = {};
                itemObject.icon = $auxCurrentItem.find('[class*="icon"]').attr('class');
                itemObject.text = $auxCurrentItem.find('.text').text();
                itemObject.indexDropdowns = $auxCurrentItem.attr('data-index-dropdown'); //ADDED DROPDOWN INDEX
                arrayOfActualItems.push(itemObject);
            }
            arrayOfActualItems = this.transportCounterClockWise(arrayOfActualItems, distanceClockWise);

            $(() => {
                function fadeOutVisidted() {
                    $('.visitedItem').removeClass('is-open');
                }
                window.setTimeout(fadeOutVisidted, 3000); // 1 second
            });
            $(() => {
                function moveItems() {
                    for (let x = 0; x < $actualItemsPosition.length; x += 1) {
                        let $currentItem = $($actualItemsPosition[x]);
                        $currentItem.find('i').removeClass(); //Removes previous classes
                        $currentItem.find('i').addClass(arrayOfActualItems[x].icon);
                        $currentItem.find('.text').html(arrayOfActualItems[x].text);
                        $currentItem.attr('data-index-dropdown', arrayOfActualItems[x].indexDropdowns); //CHANGING INTO ACTUAL ELEMENT
                    }
                    $('.visitedItem').remove();
                    for (let i = 0; i < clickedItems.length; i += 1) {
                        let auxClass = clickedItems[i].replace(' ', '.');
                        let auxItem = $(`.${auxClass}`);
                        let areaImageIndex = parseInt(auxItem.closest('li').attr('data-index-area'), 0);
                        if (areaImageIndex === 11) {
                            areaImageIndex = 1;
                        } else {
                            areaImageIndex += 1;
                        }
                        $('.background-wheel').after($('<img>', {
                            class: 'visitedItem js-lazy js-webp',
                            'data-image': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                            'data-image-webp': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                            src: `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                        }));
                    }
                }
                window.setTimeout(moveItems, 1000); // 1 second
            });

            $(() => {
                function rotateWheel(currentArrowDegree) {
                    $('.background-wheel').css('transform', `rotate(${currentArrowDegree}deg)`);
                }
                window.setTimeout(rotateWheel(currentArrowDegree), 3000); // 1 second
            });
            $(() => {
                function fadeInItems() {
                    $wheelLinksArea.removeClass('fade-out');
                    $(`.js-dropdown-index-${indexDropdown}`).removeClass('is-open');
                    indexDropdown = $('.active-slice').attr('data-index-dropdown');
                    $(`.js-dropdown-index-${indexDropdown}`).addClass('is-open');
                    $('.visitedItem').addClass('is-open');
                }
                window.setTimeout(fadeInItems, 3000);
            });
        });

        $('.links-area li a').click(e => {
            e.preventDefault();
            e.stopPropagation();
            let currentItemSelected = $(e.currentTarget).closest('li').attr('data-index-area');
            let currentItemDegree = $(e.currentTarget).closest('li').attr('data-index-degree');
            let currentElementList = $('.links-area li a');
            let distanceCounterClockwise = this.rotateCounterClockWise(currentElementList.length, currentItemSelected);
            let distanceClockWise = this.rotateClockWise(currentElementList.length, currentItemSelected);
            let arrayOfActualItems = [];
            let $actualItemsPosition = $('.links-area li');
            let expiryDate = new Date();
            expiryDate.setMonth(expiryDate.getMonth() + 1);

            if ($.inArray($(e.currentTarget).closest('li').find('i').attr('class'), clickedItems) === -1) {
                clickedItems.push($(e.currentTarget).closest('li').find('i').attr('class'));
                let jsonCookies = JSON.stringify(clickedItems);
                document.cookie = `selectionItemsCookie=${jsonCookies};expires=${expiryDate};path=/`;
            }

            if (!($('.js-wheel-wrapper').hasClass('is-open'))) {
                //initialize wheel and display dropdown section.
                let $wheelLinksArea = $('.links-area');
                $wheelLinksArea.addClass('fade-out');
                //--pass items from nodeList to array of objects for rearranging them with shift/unshift.
                for (let i = 0; i < $actualItemsPosition.length; i += 1) {
                    let $auxCurrentItem = $($actualItemsPosition[i]);
                    let itemObject = {};
                    itemObject.icon = $auxCurrentItem.find('[class*="icon"]').attr('class');
                    itemObject.text = $auxCurrentItem.find('.text').text();
                    itemObject.indexDropdowns = $auxCurrentItem.attr('data-index-dropdown'); //ADDED DROPDOWN INDEX
                    arrayOfActualItems.push(itemObject);
                }

                if (distanceClockWise < distanceCounterClockwise && distanceClockWise !== 0) {
                    arrayOfActualItems = this.transportClockWise(arrayOfActualItems, distanceClockWise);
                } else if ((distanceCounterClockwise - 1) !== 0) {
                    arrayOfActualItems = this.transportCounterClockWise(arrayOfActualItems, distanceCounterClockwise);
                }

                $(() => {
                    function fadeOutVisidted() {
                        $('.visitedItem').removeClass('is-open');
                    }
                    window.setTimeout(fadeOutVisidted, 3000); // 1 second
                });
                //--cycle through the items in array and push the different values on to the next position.
                $(() => {
                    function moveItems(clickedItems) {
                        for (let x = 0; x < $actualItemsPosition.length; x += 1) {
                            let $currentItem = $($actualItemsPosition[x]);
                            $currentItem.find('i').removeClass(); //Removes previous classes
                            $currentItem.find('i').addClass(arrayOfActualItems[x].icon);
                            $currentItem.find('.text').html(arrayOfActualItems[x].text);
                            $currentItem.attr('data-index-dropdown', arrayOfActualItems[x].indexDropdowns); //CHANGING INTO ACTUAL ELEMENT
                        }
                        $('.visitedItem').remove();
                        for (let i = 0; i < clickedItems.length; i += 1) {
                            let auxClass = clickedItems[i].replace(' ', '.');
                            let auxItem = $(`.${auxClass}`);
                            let areaImageIndex = parseInt(auxItem.closest('li').attr('data-index-area'), 0);
                            if (areaImageIndex === 11) {
                                areaImageIndex = 1;
                            } else {
                                areaImageIndex += 1;
                            }
                            $('.background-wheel').after($('<img>', {
                                class: 'visitedItem js-lazy js-webp',
                                'data-image': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                                'data-image-webp': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                                src: `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                            }));
                        }
                    }
                    window.setTimeout(moveItems(clickedItems), 3000); // 3 second
                });
                $(() => {
                    function slideWheel() {
                        $('.js-wheel-wrapper').addClass('is-open');
                    }
                    window.setTimeout(slideWheel, 1000); // 1 second
                });
                $(() => {
                    function rotateWheel(currentItemDegree) {
                        $('.background-wheel').addClass('is-open');
                        $('.background-wheel').css('transform', `rotate(${currentItemDegree}deg)`);
                        $('.hoverImage').addClass('is-open');
                        $('.wheel-section').addClass('is-open');
                    }
                    window.setTimeout(rotateWheel(currentItemDegree), 2000); 
                });
                let $activeImageElement = $('.activeImage');
                $(() => {
                    function showActiveImage() {
                        $activeImageElement.addClass('is-open');
                    }
                    window.setTimeout(showActiveImage, 4000);
                });
                $(() => {
                    function fadeInVisited() {
                        $('.visitedItem').addClass('is-open');
                    }
                    window.setTimeout(fadeInVisited, 3000); // 1 second
                });
                $(() => {
                    function fadeInItems() {
                        $wheelLinksArea.removeClass('fade-out');
                        $('.arrows-wrapper').addClass('is-open');
                        $('.dropdowns-wrapper').addClass('is-open');
                        indexDropdown = $('.active-slice').attr('data-index-dropdown');
                        $(`.js-dropdown-index-${indexDropdown}`).addClass('is-open');
                    }
                    window.setTimeout(fadeInItems, 4000);
                });
                this.calculateBottomPadding();
            } else {
                //register clicks on items wheel and rotate
                let $wheelLinksArea = $('.links-area');
                $wheelLinksArea.addClass('fade-out');

                let expiryDate = new Date();
                expiryDate.setMonth(expiryDate.getMonth() + 1);

                if ($.inArray($(e.currentTarget).closest('li').find('i').attr('class'), clickedItems) === -1) {
                    clickedItems.push($(e.currentTarget).closest('li').find('i').attr('class'));
                    let jsonCookies = JSON.stringify(clickedItems);
                    document.cookie = `selectionItemsCookie=${jsonCookies};expires=${expiryDate};path=/`;
                }

                for (let i = 0; i < $actualItemsPosition.length; i += 1) {
                    let $auxCurrentItem = $($actualItemsPosition[i]);
                    let itemObject = {};
                    itemObject.icon = $auxCurrentItem.find('[class*="icon"]').attr('class');
                    itemObject.text = $auxCurrentItem.find('.text').text();
                    itemObject.indexDropdowns = $auxCurrentItem.attr('data-index-dropdown'); //ADDED DROPDOWN INDEX
                    arrayOfActualItems.push(itemObject);
                }

                if (distanceClockWise < distanceCounterClockwise && distanceClockWise !== 0) {
                    arrayOfActualItems = this.transportClockWise(arrayOfActualItems, distanceClockWise);
                } else if ((distanceCounterClockwise - 1) !== 0) {
                    arrayOfActualItems = this.transportCounterClockWise(arrayOfActualItems, distanceCounterClockwise);
                }
                $(() => {
                    function fadeOutVisidted() {
                        $('.visitedItem').removeClass('is-open');
                    }
                    window.setTimeout(fadeOutVisidted, 3000); // 1 second
                });
                $(() => {
                    function moveItems() {
                        for (let x = 0; x < $actualItemsPosition.length; x += 1) {
                            let $currentItem = $($actualItemsPosition[x]);
                            $currentItem.find('i').removeClass(); //Removes previous classes
                            $currentItem.find('i').addClass(arrayOfActualItems[x].icon);
                            $currentItem.find('.text').html(arrayOfActualItems[x].text);
                            $currentItem.attr('data-index-dropdown', arrayOfActualItems[x].indexDropdowns); //CHANGING INTO ACTUAL ELEMENT
                        }
                        $('.visitedItem').remove();
                        for (let i = 0; i < clickedItems.length; i += 1) {
                            let auxClass = clickedItems[i].replace(' ', '.');
                            let auxItem = $(`.${auxClass}`);
                            let areaImageIndex = parseInt(auxItem.closest('li').attr('data-index-area'), 0);
                            if (areaImageIndex === 11) {
                                areaImageIndex = 1;
                            } else {
                                areaImageIndex += 1;
                            }
                            $('.background-wheel').after($('<img>', {
                                class: 'visitedItem js-lazy js-webp',
                                'data-image': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                                'data-image-webp': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                                src: `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                            }));
                        }
                    }
                    window.setTimeout(moveItems, 1000); // 1 second
                });
                $(() => {
                    function rotateWheel(currentItemDegree) {
                        $('.background-wheel').css('transform', `rotate(${currentItemDegree}deg)`);
                    }
                    window.setTimeout(rotateWheel(currentItemDegree), 2000); // 1 second
                });
                $(() => {
                    function fadeInItems() {
                        $wheelLinksArea.removeClass('fade-out');
                        $(`.js-dropdown-index-${indexDropdown}`).removeClass('is-open');
                        indexDropdown = $('.active-slice').attr('data-index-dropdown');
                        $(`.js-dropdown-index-${indexDropdown}`).addClass('is-open');
                        $('.visitedItem').addClass('is-open');
                    }
                    window.setTimeout(fadeInItems, 4000); // 3 seconds
                });
            this.calculateBottomPadding();
            }
        });

        $('.links-area').hover((e) => {}, (e) => {
            let $this = $(e.currentTarget);
            let $imgContainer = $('.hoverImage');
            let $li = $this.find('li');
            $li.removeClass('is-hovered');
            $imgContainer.attr('src', '/Content/images/custom/none.gif');
        });
    }

    calculateBottomPadding() {
        setTimeout(() => {
            let wheel = $('.wheel-section');
            let wheelHeight = $('.wheel-section').height() + $('.wheel-section').offset().top;
            let dropdowns = $('.dropdowns-wrapper');
            let dropdownsHeight = $('.dropdowns-wrapper').height() + $('.dropdowns-wrapper').offset().top;

            if (dropdownsHeight > wheelHeight) {
                let diff = dropdownsHeight - wheelHeight;
                $(wheel).css('padding-bottom', `${diff}px`);
            } else {
                $(wheel).css('padding-bottom', '110px');
            }
        }, 5200);
    }

    calculateBottomPaddingOnDropdown() {
        setTimeout(() => {
            let wheel = $('.wheel-section');
            let wheelHeight = $('.wheel-section').height() + $('.wheel-section').offset().top;
            let dropdowns = $('.dropdowns-wrapper');
            let dropdownsHeight = $('.dropdowns-wrapper').height() + $('.dropdowns-wrapper').offset().top;

            if (dropdownsHeight > wheelHeight) {
                let diff = dropdownsHeight - wheelHeight;
                $(wheel).css('padding-bottom', `${diff}px`);
            } else {
                $(wheel).css('padding-bottom', '110px');
            }
        }, 400);
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    prepExternalLinks(linksElements) {
        /*
        Rules for external links:
        1. Link is a pdf.
        2. Link is an external link (not in our hostname).
        */
        let aMockElement = document.createElement('a');
        let pdfMatches = ['.pdf', '.pdf/'];
        let hostNames = [
            'lung.org',
            'www.lung.org',
            'ala-web-dev-mvc-app.azurewebsites.net',
            'ala-web-qa-mvc-app.azurewebsites.net',
            'ala-web-test-mvc-app.azurewebsites.net',
            'ala-web-staging-mvc-app.azurewebsites.net',
            'ala-web-prod-mvc-app.azurewebsites.net',
            'ala-web-prod-mvc-app-swap.azurewebsites.net',
            'ala-kentico-mvc-web-as-prod-v3.azurewebsites.net',
            'ala-kentico-mvc-web-as-prod-v3-swap.azurewebsites.net',
            'dev.lung.org',
            'qa.lung.org',
            'staging.lung.org',
            'localhost', // TO BE DELETED... Local testing of the site.
        ];

        $(linksElements).each((i, el) => {
            // link update error catching because of IE issues
            try {
                // Copy the href.
                aMockElement.href = el.href;
                // Clear the querystrings from href.
                aMockElement.search = '';
                aMockElement.href = aMockElement.href.replace(/\?/g, '');
                let linkPath = aMockElement.href.replace(window.location.origin, '');

                // If links match, set target _blank.
                if (
                    (aMockElement.href.toLowerCase().indexOf('tel:') < 0)
                    && (linkPath.toLowerCase().indexOf('/') !== 0)
                    && (aMockElement.href.toLowerCase().indexOf('print()') < 0)
                    && (aMockElement.href.toLowerCase().indexOf('mailto:') < 0)
                    && (aMockElement.href.toLowerCase().indexOf('javascript') !== 0)
                    && (
                        $.inArray(el.hostname, hostNames) < 0 // not on whitelist
                        || aMockElement.href.slice(-4) === pdfMatches[0] // or is PDF
                        || aMockElement.href.slice(-5) === pdfMatches[1]
                    )
                ) {
                    $(el).after('<i class="icon-open"></i>');
                }
            } catch (e) {
                // eslint-disable-next-line
                console.log(e);
            }
        });
    }

    rotateCounterClockWise(maxValue, nextItemIndex) {
        let distanceToRight = 0;
        let activeItemIndex = 0; //selected item is always 1(0) because of how the numbers rotate taking the next area.
        nextItemIndex = parseInt(nextItemIndex, 0);
        nextItemIndex -= 1; // make it to 0 if it is 1

        //Detect distance to right
        while (activeItemIndex <= nextItemIndex) {
            //maybe we dont need all this logic since if active item is always 0 it would always iterate all the wheel 
            //finding the item anyways.
            if (activeItemIndex === maxValue && activeItemIndex !== nextItemIndex) {
                activeItemIndex = 0;
            } else {
                distanceToRight += 1;
                activeItemIndex += 1;
            }
        }

        return distanceToRight;
    }

    rotateClockWise(maxValue, nextItemIndex) {
        let distanceToLeft = 0;
        let activeItemIndex = 0;
        nextItemIndex = parseInt(nextItemIndex, 0);
        nextItemIndex -= 1; // make it to 0 if it is 1

        while (activeItemIndex !== nextItemIndex) {
            if (activeItemIndex === 0) {
                activeItemIndex = 11;
                distanceToLeft += 1;
            } else {
                activeItemIndex -= 1;
                distanceToLeft += 1;
            }
        }

        return distanceToLeft;
    }

    transportClockWise(actualItemsArray, distance) {
        for (let i = 0; i < (distance - 1); i += 1) {
            actualItemsArray.unshift(actualItemsArray.pop());
        }
        return actualItemsArray;
    }

    transportCounterClockWise(actualItemsArray, distance) {
        for (let i = 0; i < (distance - 1); i += 1) {
            actualItemsArray.push(actualItemsArray.shift());
        }
        return actualItemsArray;
    }

    footerAccordion(e) {
        e.stopPropagation();
        e.preventDefault();

        const target = $(e.currentTarget);

        target.toggleClass('open');
        target.closest('li').find('> ul').slideToggle();
    }

    applyVisitedItems(clickedItems) {
        for (let i = 0; i < clickedItems.length; i += 1) {
            let auxClass = clickedItems[i].replace(' ', '.');
            let auxItem = $(`.${auxClass}`);
            let areaImageIndex = parseInt(auxItem.closest('li').attr('data-index-area'), 0);
            if (areaImageIndex === 11) {
                areaImageIndex = 1;
            } else {
                areaImageIndex += 1;
            }
            $('.background-wheel').after($('<img>', {
                class: 'visitedItem js-lazy js-webp',
                'data-image': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                'data-image-webp': `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
                src: `/Content/images/wheel-health/${areaImageIndex}-visited.png`,
            }));
        }
        for (let j = 0; j < clickedItems.length; j += 1) {
            let auxClassMobile = clickedItems[j];
            let auxItemMobile = $(`*[data-icon-mobile-clicked="${auxClassMobile}"]`);
            auxItemMobile.parent().parent().addClass('is-visited');
        }
    }
}
export default HealthIndexWheel;
$(() => {
	const healthIndxWheel = new HealthIndexWheel();
	healthIndxWheel.init();
});